export const FIELD_LIMITS = {
    title: 80,
    summary: 500,
    content: 10000,
    ctaLabel: 40,
    ctaUrl: 2048
};